import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Search, Sparkles } from 'lucide-react';
const keywords = [{
  text: 'backlinks',
  radius: 140,
  duration: 20,
  delay: 0
}, {
  text: 'authority',
  radius: 180,
  duration: 25,
  delay: 2
}, {
  text: 'rankings',
  radius: 160,
  duration: 22,
  delay: 5
}, {
  text: 'traffic',
  radius: 200,
  duration: 28,
  delay: 1
}, {
  text: 'keywords',
  radius: 150,
  duration: 24,
  delay: 4
}, {
  text: 'audit',
  radius: 190,
  duration: 26,
  delay: 3
}];
export function HeroUrlInput() {
  const [url, setUrl] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  return <div className="relative flex flex-col items-center justify-center py-20 overflow-hidden min-h-[500px]" data-id="element-74">
      {/* Ambient Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-amber-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-75" />

      {/* Orbiting Keywords */}
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center" data-id="element-76">
        {keywords.map((kw, i) => <motion.div key={kw.text} className="absolute flex items-center justify-center" animate={{
        rotate: 360
      }} transition={{
        duration: kw.duration,
        repeat: Infinity,
        ease: 'linear',
        delay: -kw.delay * 5 // Negative delay to start at different positions
      }} style={{
        width: kw.radius * 2,
        height: kw.radius * 2
      }} data-id="element-77">
            <motion.div className="absolute -top-3 bg-black/40 backdrop-blur-md border border-amber-500/20 text-amber-100/70 px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap shadow-lg shadow-amber-900/10"
        // Counter-rotate to keep text upright
        animate={{
          rotate: -360
        }} transition={{
          duration: kw.duration,
          repeat: Infinity,
          ease: 'linear',
          delay: -kw.delay * 5
        }} data-id="element-78">
              {kw.text}
            </motion.div>
          </motion.div>)}

        {/* Orbital Rings */}
        {[140, 160, 180, 200].map((r, i) => <div key={r} className="absolute rounded-full border border-white/5" style={{
        width: r * 2,
        height: r * 2
      }} data-id="element-79" />)}
      </div>

      {/* Central Input Hub */}
      <motion.div className="relative z-10 w-full max-w-lg mx-auto px-4" initial={{
      scale: 0.9,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} data-id="element-80">
        <div className={`
          relative group rounded-full p-1 transition-all duration-500
          ${isFocused ? 'bg-gradient-to-r from-amber-500/50 via-amber-300/50 to-amber-500/50 shadow-[0_0_40px_-10px_rgba(245,158,11,0.3)]' : 'bg-white/10'}
        `} data-id="element-81">
          <div className="relative flex items-center bg-[#121212] rounded-full p-2 border border-white/10 shadow-2xl" data-id="element-82">
            <div className="pl-4 pr-2 text-amber-500" data-id="element-83">
              <Sparkles className="w-5 h-5" data-id="element-84" />
            </div>
            <input type="text" value={url} onChange={e => setUrl(e.target.value)} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} placeholder="Enter domain to analyze..." className="flex-1 bg-transparent border-none text-white placeholder-white/30 focus:ring-0 text-lg py-3 px-2 outline-none w-full" data-id="element-85" />
            <button className="bg-amber-500 hover:bg-amber-400 text-black font-semibold rounded-full px-8 py-3 transition-colors duration-200 flex items-center gap-2" data-id="element-86">
              Analyze <Search className="w-4 h-4" data-id="element-87" />
            </button>
          </div>
        </div>

        <motion.p className="text-center text-white/30 text-sm mt-6" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} data-id="element-88">
          Deep dive into your SEO performance metrics
        </motion.p>
      </motion.div>
    </div>;
}